import styled from 'helpers/styles';
import {css} from 'styled-components';
import ComponentStyles from 'styles/mixins/Component.styles';
import utils from 'helpers/utils';
import AppBar from 'components/atoms/Toolbars/AppBar/AppBar';

const StyledPageBar = styled(AppBar)
  .attrs((props) => {
    let attr = props;

    const vars = {
      '--page-bar-bounds-right': props.$wrapper?.boundsCum?.right ?? '0px',
      '--page-bar-bounds-left': props.$wrapper?.boundsCum?.left ?? '0px'
    };

    return utils.styleProps(attr, vars);
  })`
  color: ${props => props.theme.property('palette.text.primary')};
  background-color: ${props => props.theme.property('palette.background.paper')};

  border-bottom: 1px solid ${props => props.theme.property('palette.divider')};
  
  .PageBar {
    &-toolbar {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      min-height: unset;
      height: ${props => props.theme.layout(67)};
      column-gap: ${props => props.theme.layout('1sp')};
      padding: ${props => props.theme.spacing(1.5)} ${props => props.theme.spacing(3)};
    }
    &-navigation {
      padding-right: ${props => props.theme.spacing(1)};

      &:not(:has(*)) {
        margin-right: -${props => props.theme.spacing(1)};
      }
    }
    &-title {
      flex-grow: 1;
      width: 1px;
      max-width: fit-content;
      > .Typography {
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
    }
    
    &-center {
      display: flex;
      min-width: fit-content;
      align-items: center;
      justify-content: center;
      
      &:has(*) {
        flex: 1 0 5%;
      }

      &:not(:has(*)) {
        display: none;
      }
      
      &-wrapper {
        overflow: hidden;
        white-space: nowrap;
        left: 0;
        
        ${props => !props.$dialog ? css`
          width: calc(100vw - ${props.$css.$var('--page-bar-bounds-left')} - ${props.$css.$var('--page-bar-bounds-right')});
        ` : css`
          width: 100%;
        `}
        
        position: absolute;
        display: flex;
        justify-content: center;
        pointer-events: none;
        
        > * {
          pointer-events: all;
        }
      }
    }
    
    &-actions {
      display: flex;
      column-gap: ${props => props.theme.layout('1sp')};
      white-space: nowrap;
      align-items: center;

      &:not(:has(*)) {
        margin-left: -${props => props.theme.spacing(1)};
      }
    }
  }

  ${props => props.theme.breakpoints.down('lg')} {
    .PageBar {
      &-toolbar {
        padding: ${props => props.theme.spacing(1.5)} ${props => props.theme.spacing(2)};
      }
    }
  }
  
  ${props => props.theme.breakpoints.between('xs', 'sm')} {
    .PageBar {
      &-center {
        justify-content: flex-end;
        &-wrapper {
          width: unset;
          position: unset;
        }
      }
    }
  }
  
  ${ComponentStyles}
`;

StyledPageBar.propTypes = {
};

export default StyledPageBar;
